import type { CapabilitySource, ChatCapabilities } from 'flare-chat-core/contracts';
import type { ChatTransport } from 'flare-chat-core/transport';

/** Client action support is not backend business admission or server health. */
export const createHostCapabilities = (transport: ChatTransport, configured?: CapabilitySource): CapabilitySource => {
  const { sessions, messages, sources, stream } = transport;
  const support = {
    createSession: sessions.create, ensureActiveSession: sessions.create, selectSession: sessions.get,
    refreshSessionList: sessions.list, loadMoreSessions: sessions.list, searchSessions: sessions.list, sortSessions: sessions.list,
    loadSession: sessions.get, updateTitle: sessions.update, archiveSession: sessions.archive,
    attachFiles: sources.upload, loadOlderMessages: messages.list, send: stream.send, retry: stream.send,
    attachRun: stream.attachRun, executeOperation: stream.executeOperation,
  };
  const local = ['resetSession', 'setInputValue', 'clearInput', 'syncFileList', 'removeFile', 'abort'];
  const supported = { ...Object.fromEntries(Object.entries(support).map(([key, method]) => [key, typeof method === 'function'])),
    ...Object.fromEntries(local.map((key) => [key, true])) };
  let previous: ChatCapabilities | undefined;
  let snapshot: ChatCapabilities | undefined;
  const getSnapshot = () => {
    const input = configured?.getSnapshot();
    if (snapshot && input === previous) return snapshot;
    previous = input;
    snapshot = Object.freeze({
      actions: Object.fromEntries(Object.entries(supported).map(([key, available]) => [key,
        available && (!configured || input?.actions[key]?.available === true)
          ? { available: true } : { available: false, reason: input?.actions[key]?.reason || 'action_unavailable' },
      ])),
      items: input?.items ?? [],
    });
    return snapshot;
  };
  return { getSnapshot, subscribe: (listener) => configured?.subscribe(listener) ?? (() => {}) };
};
